const state = {
    mobileNavIsShowing: false,
    activeSubmenu: null,
};

const getters = {
    mobileNavIsShowing: state => {
        return state.mobileNavIsShowing;
    },

    mobileSubmenuIsShowing: state => {
        return state.activeSubmenu !== null;
    },

    activeSubmenu: state => {
        return state.activeSubmenu;
    },
};

const actions = {
    showMobileNav({ commit, state }) {
        commit('SHOW_MOBILE_NAV');
    },

    hideMobileNav({ commit, state }) {
        commit('HIDE_MOBILE_NAV');
    },

    toggleMobileNav({ commit, state }) {
        if (state.mobileNavIsShowing) {
            commit('HIDE_MOBILE_NAV');
        } else {
            commit('SHOW_MOBILE_NAV');
        }
    },

    toggleSubmenu({ commit, state, dispatch }, name) {
        if (state.activeSubmenu === name) {
            dispatch('deactivateSubmenu');
        } else {
            dispatch('activateSubmenu', name);
        }
    },

    activateSubmenu({ commit }, name) {
        commit('SET_ACTIVE_SUBMENU', name);
    },

    deactivateSubmenu({ commit }) {
        commit('SET_ACTIVE_SUBMENU', null);
    },
};

const mutations = {
    SHOW_MOBILE_NAV(state) {
        state.mobileNavIsShowing = true;
    },

    HIDE_MOBILE_NAV(state) {
        state.mobileNavIsShowing = false;
    },

    SET_ACTIVE_SUBMENU(state, name) {
        state.activeSubmenu = name;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
